/// <amd-module name="VSS/Features/Directory/components/DirectoryGrid/ZeroDataRow" />
import "VSS/LoaderPlugins/Css!VSS/Features/Directory/Scripts/Common/Directory/Components/DirectoryGrid";

import * as React from "react";
import { DirectoryCSS } from "./DirectoryGridConstants";
import { DetailsRow, IColumn } from "OfficeFabric/DetailsList";
import { IZeroDataRow, IZeroDataRowProps } from "./DirectoryGrid.Props";

/** Renders a message specifying there are no results. Often used in conjunction with GroupRows. */
export class ZeroDataRow extends React.PureComponent<IZeroDataRowProps> {
    public render(): JSX.Element {
        return <DetailsRow {...this.props} onRenderItemColumn={this._renderCell} />;
    }

    private _renderCell = (row: IZeroDataRow, index: number, column: IColumn): JSX.Element | undefined => {
        const { columnKey, onRenderRowContent, isGrouped } = this.props;

        return ZeroDataRow.RenderCell(row, index, column, columnKey, isGrouped, onRenderRowContent);
    };

    public static RenderCell = (
        row: IZeroDataRow,
        index: number,
        renderingColumn: IColumn,
        targetColumnKey: string,
        isGrouped: boolean,
        onRenderRowContent?: (rowKey: string) => JSX.Element | undefined
    ): JSX.Element | undefined => {
        if (renderingColumn.key === targetColumnKey) {
            return (
                <div className={DirectoryCSS.DIRECTORY_ROWITEM}>
                    {isGrouped && <div className={DirectoryCSS.DIRECTORY_GROUP_SPACER} />}
                    <div className="directory-row-title">{onRenderRowContent && onRenderRowContent(row.groupKey)}</div>
                </div>
            );
        }
    };
}
